import { render, staticRenderFns } from "./Detailppb.vue?vue&type=template&id=40717d30&scoped=true"
import script from "./Detailppb.vue?vue&type=script&lang=js"
export * from "./Detailppb.vue?vue&type=script&lang=js"
import style0 from "./Detailppb.vue?vue&type=style&index=0&id=40717d30&prod&lang=scss"
import style1 from "./Detailppb.vue?vue&type=style&index=1&id=40717d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40717d30",
  null
  
)

export default component.exports